import { render, staticRenderFns } from "./header-notification.vue?vue&type=template&id=0098ee6a"
import script from "./header-notification.vue?vue&type=script&lang=js"
export * from "./header-notification.vue?vue&type=script&lang=js"
import style0 from "./header-notification.vue?vue&type=style&index=0&id=0098ee6a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0098ee6a')) {
      api.createRecord('0098ee6a', component.options)
    } else {
      api.reload('0098ee6a', component.options)
    }
    module.hot.accept("./header-notification.vue?vue&type=template&id=0098ee6a", function () {
      api.rerender('0098ee6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header-notification.vue"
export default component.exports